/**
 * Site mode and branding for production, demo, and marketing deployments.
 * Build with REACT_APP_SITE_MODE=demo|marketing|production (default: production).
 */

import {
  BRANDING_BY_MODE,
  SITE_MODES,
  FIREBASE_HINTS,
  CONTACT,
  DEMO_USER,
  DEMO_ADMIN_USER,
} from './branding.config.js';

function resolveSiteMode() {
  const envMode = process.env.REACT_APP_SITE_MODE;
  if (envMode && BRANDING_BY_MODE[envMode]) {
    return envMode;
  }
  if (process.env.REACT_APP_DEMO_MODE === 'true') {
    return SITE_MODES.DEMO;
  }
  return SITE_MODES.PRODUCTION;
}

export const siteMode = resolveSiteMode();
export const isDemoBuild = process.env.REACT_APP_DEMO_MODE === 'true';
export const branding = BRANDING_BY_MODE[siteMode] || BRANDING_BY_MODE.production;
export const isDemoSite = branding.demoSite;
export const isMarketingSite = branding.marketingSite;

export function getLegalBranding() {
  return {
    effectiveDate: 'June 27, 2026',
    ...branding,
    isDemo: isDemoSite,
  };
}

export const FUNCTIONS_BASE = FIREBASE_HINTS.functionsBaseUrl;
export const DEMO_SITE_URL = FIREBASE_HINTS.demoSiteUrl;
export const SALES_EMAIL = CONTACT.salesEmail;

export { DEMO_USER, DEMO_ADMIN_USER };